import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Response } from '@angular/http';
import { AdminService } from '../../../services/admin.service';
import { Schedule } from '../../../models/schedule.model';
import { TimeFormatterService } from '../../../services/time-formatter.service';;

@Component({
	selector: 'app-create-group',
	templateUrl: './create-group.component.html',
	styleUrls: ['./create-group.component.css']
})

export class CreateGroupComponent implements OnInit {
	public successInfo = false;
	public errorInfo = false;
	public errorGetScheduleInfo = false;
	public errorValidateInfo = false;
	getSubdivisionsErrorInfo = false;
	getAffiliatesErrorInfo = false;
	noSubdivisionsInfo = false;
	noAffiliatesInfo = false;
	isDepartmentsLoaded = false;
	isAffiliatesLoaded = false;
	selectedSchedule: Schedule;
	selectedScheduleName = 'Select';

	private scheduleIDProp = null;

	schedulesList: any[] = [];
	schedulesListNoFormated;

	isAffiliate = false;
	isDepartment = false;
	isGlobal = false;
	// groupTypes = ['GLOBAL', 'AFFILIATE', 'DEPARTMENT'];
	groupTypes = ['DEPARTMENT'];
	subdivisions = [];
	affiliates = [];
	selectedType = '';
	selectedSubdivision = '';
	selectedSubdivisionId = '';
	selectedAffiliate = '';
	selectedAffiliateId = '';
	titleValue = '';
	prefixvalue = '';
	isCreateBtnDisabled = true;
	isCreateBtnDisabledPre = true;
	errorName = false;

	selectedSubdivisions = [];

	constructor(private adminService: AdminService, private formatService: TimeFormatterService) { }

	ngOnInit() {
		this.getScheds();
		this.selectType('DEPARTMENT');
	}

	titleValueEmpty(value) {
		value = value.trim();
		if (value !== '' && value !== undefined && value !== '') {
			this.isCreateBtnDisabled = false;
		} else {
			this.isCreateBtnDisabled = true;
		}
	}

	prefixValueEmpty(value) {
		value = value.trim();
		if (value !== '' && value !== undefined && value !== '') {
			this.isCreateBtnDisabledPre = false;
		} else {
			this.isCreateBtnDisabledPre = true;
		}
	}

	getScheds() {
		this.adminService.getSchedules().subscribe(
			(response) => {
				this.schedulesListNoFormated = response.body;
			},
			() => {
				this.errorGetScheduleInfo = true;
			},
			() => {
				// this.schedulesListNoFormated.forEach(item => {
				//   this.schedulesList.push(this.formatService.formatTime(item));
				// });
				this.selectedSched(this.schedulesListNoFormated[0]);
			}
		);
	}

	getDepartments() {
		this.adminService.getDepartmentGroups().subscribe(
			(response: any) => {
				this.subdivisions = response.body;
				this.getSubdivisionsErrorInfo = false;
				if (this.subdivisions.length > 0) {
					this.noSubdivisionsInfo = false;
					this.selectedSubdivisions = [];
				} else {
					this.noSubdivisionsInfo = true;
					this.selectedSubdivision = "NO_SUBDIVISIONS";
				}
				this.isDepartmentsLoaded = true;
			},
			() => {
				this.noSubdivisionsInfo = true;
				this.getSubdivisionsErrorInfo = true;
				this.isDepartmentsLoaded = true;
				this.selectedSubdivision = "C_A_S";
			}
		);
	}

	getAffiliates() {
		this.adminService.getAffiliateGroups().subscribe(
			(response: any) => {
				this.affiliates = response.body;
				this.getAffiliatesErrorInfo = false;
				if (this.affiliates.length > 0) {
					this.noAffiliatesInfo = false;
					this.selectAffiliate(this.affiliates[0]);
				} else {
					this.noAffiliatesInfo = true;
					this.selectedAffiliate = "NO_AFFILIATE_GROUPS";
				}
				this.isAffiliatesLoaded = true;
			},
			() => {
				this.noAffiliatesInfo = true;
				this.getAffiliatesErrorInfo = true;
				this.isAffiliatesLoaded = true;
				this.selectedAffiliate = "C_A_G";
			}
		);
	}

	selectedSched(schedule: Schedule) {
		this.selectedScheduleName = schedule.workStart.substr(0, schedule.workStart.length - 3) + ' - ' + schedule.workEnd.substr(0, schedule.workEnd.length - 3);
		this.scheduleIDProp = schedule.id;
		this.selectedSchedule = schedule;
	}

	selectType(type) {
		if (type == 'AFFILIATE') {
			this.isAffiliate = true;
			this.isDepartment = false;
			this.isGlobal = false;
			if (!this.isDepartmentsLoaded) {
				this.getDepartments();
			}
		}
		if (type == 'DEPARTMENT') {
			this.isAffiliate = false;
			this.isDepartment = true;
			this.isGlobal = false;
			this.selectedSubdivisions = [];
			if (!this.isAffiliatesLoaded) {
				this.getAffiliates();
			}
		}
		if (type == 'GLOBAL') {
			this.selectedSubdivisions = [];
			this.isGlobal = true;
			this.isAffiliate = false;
			this.isDepartment = false;
			if (!this.isAffiliatesLoaded) {
				this.getAffiliates();
			}
		}
		this.selectedType = type;
	}

	selectSubdivision(subdivision) {
		this.selectedSubdivision = subdivision.name;
		this.selectedSubdivisionId = subdivision.id;
	}

	selectAffiliate(affiliate) {
		this.selectedAffiliate = affiliate.name;
		this.selectedAffiliateId = affiliate.id;
	}

	appendSubdivision(subdivision) {

		if (this.selectedSubdivisions.includes(subdivision)) {
			const index: number = this.selectedSubdivisions.indexOf(subdivision);
			if (index !== -1) {
				this.selectedSubdivisions.splice(index, 1);
			}
		} else {
			this.selectedSubdivisions.push(subdivision);
		}
	}

	isSelectedSubdivision(subdivision) {
		return this.selectedSubdivisions.includes(subdivision);
	}

	createDivision(name, prefix) {
		this.titleValue = name;
		this.prefixvalue = prefix;

		const group = {
			name: this.titleValue,
			namePrefixStandard: this.prefixvalue,
			workScheduleId: this.selectedSchedule.id,
			groupType: this.selectedType,
			relativeGroup: [
				this.selectedSubdivisionId
			]
		};

		if (this.selectedType === 'GLOBAL') {
			group.relativeGroup = [];
			group.relativeGroup = this.selectedSubdivisions;
		}

		if (this.selectedType === 'AFFILIATE') {
			group.relativeGroup = [];
			group.relativeGroup = this.selectedSubdivisions;
		}


		if (this.selectedType === 'DEPARTMENT') {
			group.relativeGroup = [];
			group.relativeGroup.push(this.selectedAffiliateId);
		}

		this.adminService.createGroup(group).subscribe(
			(response: any) => {
				if (response.status === 201) {
					this.successInfo = true;
					this.errorInfo = false;
					this.errorName = false;
					this.getDepartments();
					this.getAffiliates();
					setTimeout(() => this.successInfo = false, 2000);
				}
			},
			() => {
				this.successInfo = false;
				this.errorInfo = true;
				setTimeout(() => this.errorInfo = false, 2000);
			}
		);
	}
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/admin/create-group/create-group.component.ts